import React from "react";

interface LearningProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const Learning: React.FC<LearningProps> = ({
  width = 20,
  height = 16,
  fillColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_329_1074)">
        <path
          d="M3.15539 15H0.84667C0.379969 15 0 14.6608 0 14.2441V1.75586C0 1.33922 0.379969 1 0.84667 1H3.15333C3.62003 1 4 1.33922 4 1.75586V14.2423C4 14.6589 3.62003 14.9982 3.15333 14.9982L3.15539 15ZM1.03252 14.0782H2.96954V1.92178H1.03252V14.0782Z"
          fill={fillColor}
        />
        <path
          d="M3.15539 15H0.84667C0.379969 15 0 14.6608 0 14.2441V1.75586C0 1.33922 0.379969 1 0.84667 1H3.15333C3.62003 1 4 1.33922 4 1.75586V14.2423C4 14.6589 3.62003 14.9982 3.15333 14.9982L3.15539 15ZM1.03252 14.0782H2.96954V1.92178H1.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M3.15539 15H0.84667C0.379969 15 0 14.6608 0 14.2441V1.75586C0 1.33922 0.379969 1 0.84667 1H3.15333C3.62003 1 4 1.33922 4 1.75586V14.2423C4 14.6589 3.62003 14.9982 3.15333 14.9982L3.15539 15ZM1.03252 14.0782H2.96954V1.92178H1.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M3.15539 15H0.84667C0.379969 15 0 14.6608 0 14.2441V1.75586C0 1.33922 0.379969 1 0.84667 1H3.15333C3.62003 1 4 1.33922 4 1.75586V14.2423C4 14.6589 3.62003 14.9982 3.15333 14.9982L3.15539 15ZM1.03252 14.0782H2.96954V1.92178H1.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M3.484 12H0.515996C0.231166 12 0 11.7996 0 11.5528V4.44723C0 4.20036 0.231166 4 0.515996 4H3.484C3.76883 4 4 4.20036 4 4.44723V11.551C4 11.7979 3.76883 11.9982 3.484 11.9982V12ZM1.03199 11.1055H2.96801V4.89445H1.03199V11.1038V11.1055Z"
          fill={fillColor}
        />
        <path
          d="M3.484 12H0.515996C0.231166 12 0 11.7996 0 11.5528V4.44723C0 4.20036 0.231166 4 0.515996 4H3.484C3.76883 4 4 4.20036 4 4.44723V11.551C4 11.7979 3.76883 11.9982 3.484 11.9982V12ZM1.03199 11.1055H2.96801V4.89445H1.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M3.484 12H0.515996C0.231166 12 0 11.7996 0 11.5528V4.44723C0 4.20036 0.231166 4 0.515996 4H3.484C3.76883 4 4 4.20036 4 4.44723V11.551C4 11.7979 3.76883 11.9982 3.484 11.9982V12ZM1.03199 11.1055H2.96801V4.89445H1.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M3.484 12H0.515996C0.231166 12 0 11.7996 0 11.5528V4.44723C0 4.20036 0.231166 4 0.515996 4H3.484C3.76883 4 4 4.20036 4 4.44723V11.551C4 11.7979 3.76883 11.9982 3.484 11.9982V12ZM1.03199 11.1055H2.96801V4.89445H1.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.15539 15H3.84667C3.37997 15 3 14.6608 3 14.2441V1.75586C3 1.33922 3.37997 1 3.84667 1H6.15333C6.62003 1 7 1.33922 7 1.75586V14.2423C7 14.6589 6.62003 14.9982 6.15333 14.9982L6.15539 15ZM4.03252 14.0782H5.96954V1.92178H4.03252V14.0782Z"
          fill={fillColor}
        />
        <path
          d="M6.15539 15H3.84667C3.37997 15 3 14.6608 3 14.2441V1.75586C3 1.33922 3.37997 1 3.84667 1H6.15333C6.62003 1 7 1.33922 7 1.75586V14.2423C7 14.6589 6.62003 14.9982 6.15333 14.9982L6.15539 15ZM4.03252 14.0782H5.96954V1.92178H4.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.15539 15H3.84667C3.37997 15 3 14.6608 3 14.2441V1.75586C3 1.33922 3.37997 1 3.84667 1H6.15333C6.62003 1 7 1.33922 7 1.75586V14.2423C7 14.6589 6.62003 14.9982 6.15333 14.9982L6.15539 15ZM4.03252 14.0782H5.96954V1.92178H4.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.15539 15H3.84667C3.37997 15 3 14.6608 3 14.2441V1.75586C3 1.33922 3.37997 1 3.84667 1H6.15333C6.62003 1 7 1.33922 7 1.75586V14.2423C7 14.6589 6.62003 14.9982 6.15333 14.9982L6.15539 15ZM4.03252 14.0782H5.96954V1.92178H4.03252V14.0782Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.484 12H3.516C3.23117 12 3 11.7996 3 11.5528V4.44723C3 4.20036 3.23117 4 3.516 4H6.484C6.76883 4 7 4.20036 7 4.44723V11.551C7 11.7979 6.76883 11.9982 6.484 11.9982V12ZM4.03199 11.1055H5.96801V4.89445H4.03199V11.1038V11.1055Z"
          fill={fillColor}
        />
        <path
          d="M6.484 12H3.516C3.23117 12 3 11.7996 3 11.5528V4.44723C3 4.20036 3.23117 4 3.516 4H6.484C6.76883 4 7 4.20036 7 4.44723V11.551C7 11.7979 6.76883 11.9982 6.484 11.9982V12ZM4.03199 11.1055H5.96801V4.89445H4.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.484 12H3.516C3.23117 12 3 11.7996 3 11.5528V4.44723C3 4.20036 3.23117 4 3.516 4H6.484C6.76883 4 7 4.20036 7 4.44723V11.551C7 11.7979 6.76883 11.9982 6.484 11.9982V12ZM4.03199 11.1055H5.96801V4.89445H4.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M6.484 12H3.516C3.23117 12 3 11.7996 3 11.5528V4.44723C3 4.20036 3.23117 4 3.516 4H6.484C6.76883 4 7 4.20036 7 4.44723V11.551C7 11.7979 6.76883 11.9982 6.484 11.9982V12ZM4.03199 11.1055H5.96801V4.89445H4.03199V11.1038V11.1055Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M12.6317 15.1355C12.532 15.1355 12.4303 15.1148 12.3343 15.0753C12.1442 14.9962 11.9955 14.8475 11.9164 14.6574L7.05807 2.87012C6.89619 2.47671 7.08442 2.02494 7.47783 1.86118L9.42231 1.05929C9.61431 0.980235 9.82325 0.980235 10.0134 1.05929C10.2035 1.13835 10.3522 1.28706 10.4312 1.47718L15.2915 13.2645C15.3705 13.4546 15.3705 13.6654 15.2915 13.8555C15.2124 14.0457 15.0637 14.1944 14.8736 14.2734L12.9291 15.0753C12.835 15.1148 12.7352 15.1337 12.6355 15.1337L12.6317 15.1355ZM7.9936 2.66682L12.724 14.1417L14.356 13.4697L9.6256 1.99482L7.9936 2.66871V2.66682Z"
          fill={fillColor}
        />
        <path
          d="M12.6317 15.1355C12.532 15.1355 12.4303 15.1148 12.3343 15.0753C12.1442 14.9962 11.9955 14.8475 11.9164 14.6574L7.05807 2.87012C6.89619 2.47671 7.08442 2.02494 7.47783 1.86118L9.42231 1.05929C9.61431 0.980235 9.82325 0.980235 10.0134 1.05929C10.2035 1.13835 10.3522 1.28706 10.4312 1.47718L15.2915 13.2645C15.3705 13.4546 15.3705 13.6654 15.2915 13.8555C15.2124 14.0457 15.0637 14.1944 14.8736 14.2734L12.9291 15.0753C12.835 15.1148 12.7352 15.1337 12.6355 15.1337L12.6317 15.1355ZM7.9936 2.66682L12.724 14.1417L14.356 13.4697L9.6256 1.99482L7.9936 2.66871V2.66682Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M12.6317 15.1355C12.532 15.1355 12.4303 15.1148 12.3343 15.0753C12.1442 14.9962 11.9955 14.8475 11.9164 14.6574L7.05807 2.87012C6.89619 2.47671 7.08442 2.02494 7.47783 1.86118L9.42231 1.05929C9.61431 0.980235 9.82325 0.980235 10.0134 1.05929C10.2035 1.13835 10.3522 1.28706 10.4312 1.47718L15.2915 13.2645C15.3705 13.4546 15.3705 13.6654 15.2915 13.8555C15.2124 14.0457 15.0637 14.1944 14.8736 14.2734L12.9291 15.0753C12.835 15.1148 12.7352 15.1337 12.6355 15.1337L12.6317 15.1355ZM7.9936 2.66682L12.724 14.1417L14.356 13.4697L9.6256 1.99482L7.9936 2.66871V2.66682Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M12.6317 15.1355C12.532 15.1355 12.4303 15.1148 12.3343 15.0753C12.1442 14.9962 11.9955 14.8475 11.9164 14.6574L7.05807 2.87012C6.89619 2.47671 7.08442 2.02494 7.47783 1.86118L9.42231 1.05929C9.61431 0.980235 9.82325 0.980235 10.0134 1.05929C10.2035 1.13835 10.3522 1.28706 10.4312 1.47718L15.2915 13.2645C15.3705 13.4546 15.3705 13.6654 15.2915 13.8555C15.2124 14.0457 15.0637 14.1944 14.8736 14.2734L12.9291 15.0753C12.835 15.1148 12.7352 15.1337 12.6355 15.1337L12.6317 15.1355ZM7.9936 2.66682L12.724 14.1417L14.356 13.4697L9.6256 1.99482L7.9936 2.66871V2.66682Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M11.3483 12.5091C11.2862 12.5091 11.226 12.4978 11.1676 12.4734C11.0528 12.4263 10.9606 12.3341 10.9135 12.2174L8.06361 5.30538C8.01656 5.19055 8.01656 5.06067 8.06361 4.94585C8.11067 4.83102 8.20291 4.73879 8.31961 4.69173L10.8213 3.6602C11.0622 3.56232 11.337 3.67526 11.4349 3.9162L14.2848 10.8263C14.3319 10.9411 14.3319 11.071 14.2848 11.1858C14.2377 11.3007 14.1455 11.3929 14.0288 11.44L11.5271 12.4715C11.4688 12.496 11.4086 12.5073 11.3483 12.5073V12.5091ZM9.11397 5.38443L11.6043 11.4249L13.2363 10.751L10.746 4.71055L9.11397 5.38443Z"
          fill={fillColor}
        />
        <path
          d="M11.3483 12.5091C11.2862 12.5091 11.226 12.4978 11.1676 12.4734C11.0528 12.4263 10.9606 12.3341 10.9135 12.2174L8.06361 5.30538C8.01656 5.19055 8.01656 5.06067 8.06361 4.94585C8.11067 4.83102 8.20291 4.73879 8.31961 4.69173L10.8213 3.6602C11.0622 3.56232 11.337 3.67526 11.4349 3.9162L14.2848 10.8263C14.3319 10.9411 14.3319 11.071 14.2848 11.1858C14.2377 11.3007 14.1455 11.3929 14.0288 11.44L11.5271 12.4715C11.4688 12.496 11.4086 12.5073 11.3483 12.5073V12.5091ZM9.11397 5.38443L11.6043 11.4249L13.2363 10.751L10.746 4.71055L9.11397 5.38443Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M11.3483 12.5091C11.2862 12.5091 11.226 12.4978 11.1676 12.4734C11.0528 12.4263 10.9606 12.3341 10.9135 12.2174L8.06361 5.30538C8.01656 5.19055 8.01656 5.06067 8.06361 4.94585C8.11067 4.83102 8.20291 4.73879 8.31961 4.69173L10.8213 3.6602C11.0622 3.56232 11.337 3.67526 11.4349 3.9162L14.2848 10.8263C14.3319 10.9411 14.3319 11.071 14.2848 11.1858C14.2377 11.3007 14.1455 11.3929 14.0288 11.44L11.5271 12.4715C11.4688 12.496 11.4086 12.5073 11.3483 12.5073V12.5091ZM9.11397 5.38443L11.6043 11.4249L13.2363 10.751L10.746 4.71055L9.11397 5.38443Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
        <path
          d="M11.3483 12.5091C11.2862 12.5091 11.226 12.4978 11.1676 12.4734C11.0528 12.4263 10.9606 12.3341 10.9135 12.2174L8.06361 5.30538C8.01656 5.19055 8.01656 5.06067 8.06361 4.94585C8.11067 4.83102 8.20291 4.73879 8.31961 4.69173L10.8213 3.6602C11.0622 3.56232 11.337 3.67526 11.4349 3.9162L14.2848 10.8263C14.3319 10.9411 14.3319 11.071 14.2848 11.1858C14.2377 11.3007 14.1455 11.3929 14.0288 11.44L11.5271 12.4715C11.4688 12.496 11.4086 12.5073 11.3483 12.5073V12.5091ZM9.11397 5.38443L11.6043 11.4249L13.2363 10.751L10.746 4.71055L9.11397 5.38443Z"
          fill={fillColor}
          fill-opacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_329_1074">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Learning;

